<script>
    import API from "../services/Api";
    import AutoComplete from "simple-svelte-autocomplete"

    let formSubmitted =false;

    let query = "";
    let waitingRequest = false;
    let ticketNotFound = false;
    let badRequest = false;
    let stockCreated = false;
    let requestFailed = false;
    let connectionFailed = false;
    let data = {};
    let request = {};
    let stock = {};
    let items = [];
    let materialItems = [];
    let materialsList = [];
    let dateSubmit = '';
    let itemSelected = {
        quantity: 0,
        title: "",
        id: null,
        serial: "",
        item: {}
    };

    let changeValueChangeONU = () => {
        if (request.changeonu == undefined) {
            request.changeonu = true;
        } else {
            request.changeonu = !request.changeonu;
        }
    };

    let pesquisar = () => {
        ticketNotFound = false;
        requestFailed = false;
        connectionFailed = false;
        stockCreated = false;
        data = {};
        request = {};
        stock = {};

        if (query.length < 10 || query.length > 19 || query === "" || isNaN(query) === true) {
        // if (query.length != 19 || query === "" || isNaN(query) === true) {
            console.log(query.length);
            alert("Informe um número de protocolo válido para realizar a pesquisa");
            return;
        }

        data = {
                    "name": "OFFICE TRACK",
                    "companyName": "OFFICE TRACK",
                    "protocol": query,
                }
                
        waitingRequest = false;
        request.protocol = data.protocol;
        request.clientid = data.clientID;
    };

    let searchMaterialIems = async () => {

        materialItems = [];

        await API.get(`materialItemsCorp?typeService=${request.typeservice}`)
            .then((response) => {
                //materialItems = response.data;
                materialItems = [{id:null,code:"",description: ''}].concat(response.data);

                if (materialItems[0]) {
                    itemSelected.item = materialItems[0];
                }

                materialsList = materialItems;
            })
            .catch((err) => {
                console.log(err);
            });
    };

    let addItemsMaterial = () => {

        if (itemSelected.item.id === null || itemSelected.item.id === undefined) {
            alert('Selecione um item');
            return;
        }

        if (itemSelected.quantity == 0 || itemSelected.quantity == undefined) {
            alert('Informe uma quantidade acima de 0');
            return;
        }

        items.push({
            title: itemSelected.item.description,
            id: itemSelected.item.id,
            quantity: itemSelected.quantity,
            code: itemSelected.item.code,
            serial: itemSelected.serial
        });

        materialItems = [];
        materialItems = materialsList;

        items = items;

        itemSelected = {
            quantity: 0,
            title: "",
            id: null,
            code:"",
            serial: "",
            item: {
                description:"",
                code:""
            }
        };
    };

    let submit = async () => {
        waitingRequest = true;
        requestFailed = false;
        connectionFailed = false;
        badRequest = false;
        stock = {};
        request.items = items;


        await API.post("stockb2bOtrs", request)
            .then((response) => {
                stock = response.data;
                stockCreated = true;
                waitingRequest = false;
                dateSubmit = new Date().toLocaleString()
                console.log(response);
            })
            .catch((err) => {
                console.log(err);
                if (err.response) {
                    switch (err.response.status) {
                        case 400:
                            badRequest = true;
                            break;
                        case 500:
                            requestFailed = true;
                            break;
                    }
                } else {
                    connectionFailed = true;
                }
                waitingRequest = false;
            });
    };

  function removeItem(item) {
    items = items.filter(i => i !== item);
  }

</script>

<main style="">
    <div class="">
        <div class="card-body">
            <h2>BAIXA DE MATERIAL</h2> 
            <h6 class="font-weight-normal">MANUTENÇÃO / PARCEIRA</h6>
            <h6 class="font-weight-normal">Sistema OFFICE TRACK</h6>
            {#if !stock.id}
            {#if !waitingRequest}
            <div class="input-group mb-3">
                <input
                    type="text"
                    placeholder="Informe o protocolo do OFFICE TRACK"
                    bind:value={query}
                    class="form-control"
                />
                <div class="input-group-append">
                    <button
                        class="btn btn-outline-secondary"
                        on:click={pesquisar}
                    >
                        Ir
                    </button>
                </div>
            </div>
            {:else}
                <div class=""><span>Aguarde...</span></div>
            {/if}
            {/if}

            {#if ticketNotFound}
                <div class="text-danger text-center">
                    Chamado não encontrado.<br />Verifique as informações e tente novamente!
                </div>
            {/if}

            {#if stockCreated}
                <div
                    class="alert alert-success d-flex align-items-center"
                    role="alert"
                >
                    <svg class="bi flex-shrink-0 me-2" width="24" height="24"
                        ><use xlink:href="#check-circle-fill" /></svg
                    >
                    <div>Solicitação realizada com sucesso!</div>
                </div>
            {/if}

            {#if requestFailed}
                <div class="text-danger text-center">
                    Não foi possível realizar a pesquisa.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            {#if connectionFailed}
                <div class="text-danger text-center">
                    Houve falha de comunicação com o servidor.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            {#if request.protocol && !waitingRequest}
                <div class="accordion" id="accordionExample">
                    {#if data.clientID}
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <h6
                                class="mb-0"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                            >
                                #1 Dados cadastrais
                            </h6>
                        </div>
                        <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                        >
                            <div class="card-body">
                                <p>ID Cliente: {data.clientID}</p>
                                <p>Nome: {data.name}</p>
                                {#if data.CNPJ}
                                    <p>CNPJ: {data.CNPJ}</p>
                                    <p>
                                        Nome fantasia:
                                        {data.companyName}
                                    </p>
                                {/if}

                                {#if data.CPF}
                                    <p>CPF: {data.CPF}</p>
                                {/if}
                                <!-- <p>Telefone: {data.phone}</p>
                                <p>Celular: {data.cellPhone}</p> -->
                            </div>
                        </div>
                    </div>
                    {/if}
                    {#if !stock.id}
                        <div class="card">
                            <div class="card-header" id="headingTwo">
                                <h6
                                    class="mb-0"
                                    data-toggle="collapse"
                                    data-target="#collapseTwo"
                                    aria-expanded="true"
                                    aria-controls="collapseTwo"
                                >
                                    Informações de execução

                                </h6>
                            </div>
                            <div
                                id="collapseTwo"
                                class="collapse show"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample"
                            >
                                <div class="card-body">
                                    <div class="mb-3">
                                        <label
                                            class="form-label"
                                            for="selectUF"
                                            >Estado
                                        </label>
                                        <select
                                            class="form-control"
                                            id="selectUF"
                                            bind:value={request.uf}>
                                            <option>Selecione...</option>
                                            <option value="AC">Acre (AC)</option>
                                            <option value="AL">Alagoas (AL)</option>
                                            <option value="AP">Amapá (AP)</option>
                                            <option value="AM">Amazonas (AM)</option>
                                            <option value="BA">Bahia (BA)</option>
                                            <option value="CE">Ceará (CE)</option>
                                            <option value="DF">Distrito Federal (DF)</option>
                                            <option value="ES">Espírito Santo (ES)</option>
                                            <option value="GO">Goiás (GO)</option>
                                            <option value="MA">Maranhão (MA)</option>
                                            <option value="MT">Mato Grosso (MT)</option>
                                            <option value="MS">Mato Grosso do Sul (MS)</option>
                                            <option value="MG">Minas Gerais (MG)</option>
                                            <option value="PA">Pará (PA)</option>
                                            <option value="PB">Paraíba (PB)</option>
                                            <option value="PR">Paraná (PR)</option>
                                            <option value="PE">Pernambuco (PE)</option>
                                            <option value="PI">Piauí (PI)</option>
                                            <option value="RJ">Rio de Janeiro (RJ)</option>
                                            <option value="RN">Rio Grande do Norte (RN)</option>
                                            <option value="RS">Rio Grande do Sul (RS)</option>
                                            <option value="RO">Rondônia (RO)</option>
                                            <option value="RR">Roraima (RR)</option>
                                            <option value="SC">Santa Catarina (SC)</option>
                                            <option value="SP">São Paulo (SP)</option>
                                            <option value="SE">Sergipe (SE)</option>
                                            <option value="TO">Tocantins (TO)</option>
                                        </select>
                                    </div>
                                    <div class="mb-3">
                                        <label
                                            class="form-label"
                                            for="selectTypeService"
                                            >Tipo de serviço
                                        </label>
                                        <select
                                            class="form-control"
                                            id="selectTypeService"
                                            bind:value={request.typeservice}
                                            on:blur={searchMaterialIems}>
                                            <option>Selecione...</option>
                                            <option value="ATIVACAO">Ativação</option>
                                            <option value="MANUTENCAO REDES">Manutenção de Redes</option>
                                            <option value="MANUTENCAO B2B">B2B Manutenção</option>
                                            <option value="MIGRACAO_POP">Migração de POP</option>
                                            <option value="MELHORIA_POP">Melhoria de POP</option>
                                            <option value="FORMATACAO_FIBRA">Formatação de Fibra</option>
                                            <option value="IMPLANTACAO">Implantação</option>
                                            <option value="FTTA">FTTA</option>
                                        </select>
                                    </div>
                                    {#if request.typeservice === "ATIVACAO"}
                                        <div class="mb-3">
                                            <label
                                                for="cmoAnalyst"
                                                class="form-label"
                                                >Analista CMO</label
                                            >
                                            <input
                                                id="cmoAnalyst"
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.cmo_analyst}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label
                                                for="fusionTechnical1"
                                                class="form-label"
                                                >Técnico Responsável 1</label
                                            >
                                            <input
                                                id="fusionTechnical1"
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.technical_responsible_fusion_1}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label
                                                for="fusionTechnical2"
                                                class="form-label"
                                                >Técnico Responsável 2</label
                                            >
                                            <input
                                                id="fusionTechnical2"
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.technical_responsible_fusion_2}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label
                                                for="sendingTechnical"
                                                class="form-label"
                                                >Técnico Responsável
                                                (lançamento)</label
                                            >
                                            <input
                                                id="sendingTechnical"
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.technical_responsible_sending}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label">
                                                Local caixa 1
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.box_local_1}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label"
                                                >Responsável pela validação no
                                                cliente</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.validation_responsible}
                                            />
                                        </div>
                                    {/if}

                                    {#if request.typeservice === "MANUTENCAO REDES" || request.typeservice === "MANUTENCAO B2B" || request.typeservice === "MIGRACAO_POP" || request.typeservice === "MELHORIA_POP" || request.typeservice === "FORMATACAO_FIBRA" || request.typeservice === "IMPLANTACAO" || request.typeservice === "FTTA"}
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label"
                                                >Analista CMO</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.cmo_analyst}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label">Técnico 1</label>
                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.technical_responsible_fusion_1}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label">Técnico 2</label>

                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.technical_responsible_fusion_2}
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label">Técnico 3</label>

                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={request.technical_responsible_sending}
                                            />
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <h6
                                    class="mb-0"
                                    data-toggle="collapse"
                                    data-target="#collapseThree"
                                    aria-expanded="true"
                                    aria-controls="collapseThree"
                                >
                                    Materiais
                                </h6>
                            </div>
                            <div
                                id="collapseThree"
                                class="collapse show"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample"
                            >
                                <div class="card-body">
                                    <div class="mb-3">
                                        <label
                                            for="itemMaterialAdd"
                                            class="form-label">Item</label
                                        >
                                    {#if request.typeservice === "Selecione..."}
                                        <div>
                                            <input class="form-control" disabled/>
                                        </div>
                                    {:else}
                                        <div>
                                            <AutoComplete items="{materialItems}" 
                                                bind:selectedItem="{itemSelected.item}" 
                                                labelFieldName="code"
                                            />
                                        </div>
                                        <label
                                            for="itemMaterialAdd"
                                            class="form-label">Descrição</label
                                        >
                                        <div>
                                            <AutoComplete items="{materialItems}" 
                                                bind:selectedItem="{itemSelected.item}" 
                                                labelFieldName="description"
                                            />
                                        </div>
                                    {/if}
                                        <br>
                                        <label
                                            for="quantidadeMaterialAdd"
                                            class="form-label">Quantidade</label
                                        >
                                        <input 
                                            type="number"
                                            class="form-control"
                                            id="quantidadeMaterialAdd"
                                            bind:value={itemSelected.quantity}
                                            placeholder="Apenas números"
                                        />
                                        <br>
                                        <div class="mb-3">
                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                            <label class="form-label">Serial Equipamento</label>

                                            <input
                                                type="text"
                                                class="form-control form-control-lg"
                                                bind:value={itemSelected.serial}
                                            />
                                        </div>
                                        <button type="button" class="btn btn-primary" on:click={addItemsMaterial}>
                                            Adicionar item
                                        </button>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table">
                                          <thead>
                                            <tr>
                                              <th>Remover</th>
                                              <th>Qtd</th>
                                              <th>Código</th>
                                              <th>Item</th>
                                              <th>Serial</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {#each items as item}
                                            <tr>
                                            <td>
                                                <button class="btn btn-danger pt-0 pb-1" on:click={() => removeItem(item)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                                                    </svg>
                                                </button>
                                            </td>
                                            <td>{item.quantity}</td>
                                            <td>{item.code}</td>
                                            <td class="text-nowrap">{item.title}</td>
                                            <td class="text-nowrap">{item.serial}</td>
                                            </tr>
                                            {/each}
                                          </tbody>
                                        </table>
                                      </div>


                                    {#if items.length < 1}
                                        <button disabled type="button" class="btn btn-success btn-block">
                                            Finalizar
                                        </button>
                                    {:else} 
                                        <button type="button" class="btn btn-success btn-block" on:click={submit}>
                                            Finalizar
                                        </button>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if stock.id}
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <h6
                                    class="mb-0"
                                    data-toggle="collapse"
                                    data-target="#collapseThree"
                                    aria-expanded="true"
                                    aria-controls="collapseThree"
                                >
                                    # Solicitação
                                </h6>
                            </div>
                        <div
                            id="collapseThree"
                            class="collapse show"
                            aria-labelledby="headingthree"
                            data-bs-parent="#accordionExample"
                        >
                            <div id="Table"></div>
                                <div class="card-body">
                                    <p>Baixa realizada: {dateSubmit || ""}</p>
                                    <p>Protocolo OFFICE TRACK: {request.protocol || ""}</p>
                                    <p>Tipo de serviço: {request.typeservice || ""}</p>
                                    <p>Usuário: {request.user.name || ""}</p>
                                    {#if stock.cmo_analyst}
                                        <p>Analista CMO: {stock.cmo_analyst || ""}</p>
                                    {/if}
                                    {#if stock.technical_responsible_fusion_1}
                                        <p>Técnico 1: {stock.technical_responsible_fusion_1 || ""}</p>
                                    {/if}
                                    {#if stock.technical_responsible_fusion_2}
                                        <p>Técnico 2: {stock.technical_responsible_fusion_2 || ""}</p>
                                    {/if}
                                    {#if stock.technical_responsible_sending}
                                        <p>Técnico 3: {stock.technical_responsible_sending || ""}</p>
                                    {/if}
                                    {#if stock.box_local_1}
                                        <p>Local caixa 1: {stock.box_local_1 || ""}</p>
                                    {/if}
                                    {#if stock.validation_responsible}
                                        <p>Responsável pela validação no cliente: {stock.validation_responsible || ""}</p>
                                    {/if}
                                    <div class="table-responsive">
                                        <table class="table">
                                          <thead>
                                            <tr>
                                              <th>Qtd</th>
                                              <th>Código</th>
                                              <th>Item</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {#each items as item}
                                                <tr>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.code}</td>
                                                    <td class="text-nowrap">{item.title}</td>
                                                </tr>
                                            {/each}
                                          </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    {/if}
                </div>
            {/if}
        </div>
    </div>
</main>
